import React from 'react';
import map from 'lodash/map';
import swal from 'sweetalert2';
import classNames from 'classnames';
import orderBy from 'lodash/orderBy';
import isEmpty from 'lodash/isEmpty';
import {connect} from 'react-redux';

import Loader from '../../../../../components/Loader';
import Filters from '../../../../../components/Filters';
import {getDivisionInfos} from '../../../../../pages/Support/League/Widgets/LeagueInfo';

import FilterInput from '../../../../../components/Filters/Input';

import {fetchRankingByDivision} from '../../../../../actions/entities/league';

import './index.css';
import {getEndpoint, getHeaders} from '../../../../../helpers/endpoint';

const cols = {
  rank: 'Rank',
  name: 'Team Name',
  userId: 'User ID',
  points: 'Points',
  played: 'Match played',
  won: 'Win',
  drawn: 'Draw',
  lost: 'Loose',
  difference: 'Goal Average',
};

class SupportLeagueRankingWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: {
        divisionId: props.divisionId || '',
      },
      order: {key: 'rank', value: 'asc'},
      isFetching: false,
      highlightRefreshBtn: true,
      divisionInfos: undefined,
    };
  }

  getDivisionUsers = payload => {
    return (_dispatch, getState) => {
      fetch(getEndpoint('getDivisionUsers', payload.divisionId), {
        method: 'GET',
        headers: getHeaders(getState().authentication),
      })
        .then(response => response.json())
        .then(data => {
          if (data.error) {
            payload.onError && payload.onError();
          } else {
            payload.onSuccess && payload.onSuccess(data);
          }
        });
    };
  };

  updateFilters(filter) {
    this.setState({filters: {...this.state.filters, ...filter}});
  }

  notifyRefresh(value) {
    const {highlightRefreshBtn} = this.state;
    this.setState({
      highlightRefreshBtn: value !== undefined ? value : !highlightRefreshBtn,
    });
  }

  selectOrChangeOrder(key) {
    if (key === this.state.order.key)
      this.setState({
        order: {key, value: this.state.order.value === 'asc' ? 'desc' : 'asc'},
      });
    else {
      const newOrder = {key};
      // The switch is necessary for the default sortOrder each orderType
      switch (key) {
        case 'rank':
          newOrder.value = 'asc';
          break;
        default:
          newOrder.value = 'desc';
      }
      this.setState({order: newOrder});
    }
  }

  onError = error => {
    this.setState({isFetching: false});
    swal({
      title: `Oops...`,
      type: 'error',
      html:
        `Something went wrong !<br/>${error}<br/>` +
        `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
    });
  };

  fetchData(
    divisionId = this.state.filters.divisionId,
    gamesWeek = this.state.filters.gamesWeek,
  ) {
    const callBacks = {
      onError: this.onError,
      onRequest: () => this.setState({isFetching: true}),
      onSuccess: () => {
        this.setState({isFetching: false});
        this.notifyRefresh(false);
      },
    };

    if (!this.state.isFetching && !isEmpty(divisionId)) {
      const payload = {
        divisionId: `${divisionId}`,
        gamesWeek,
      };

      this.props.dispatch(
        getDivisionInfos({
          divisionId,
          onSuccess: divisionInfos =>
            this.setState({divisionInfos: divisionInfos.division}),
        }),
      );
      this.props.dispatch(fetchRankingByDivision(payload, callBacks));
    }
  }

  renderTable() {
    const {order, divisionInfos} = this.state;
    const {data} = this.props;
    if (!data.standings || !divisionInfos)
      return <p className="text-center px-3 pb-3">No data to show</p>;

    console.log(divisionInfos);

    return (
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>{this.renderThs(cols)}</tr>
          </thead>
          <tbody>
            {orderBy(
              data.standings,
              [order.key, 'id'],
              [order.value, 'desc'],
            ).map((t, i) => {
              let userId;
              Object.keys(divisionInfos.usersTeams).forEach(UserId => {
                if (divisionInfos.usersTeams[UserId] === t.teamId) {
                  userId = UserId;
                }
              });
              console.log(userId);
              return SupportLeagueRankingWidget.renderTr(
                {
                  ...t,
                  name: divisionInfos.teamsById[t.teamId].name,
                  userId,
                },
                i,
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  static renderTr(o, key, onClick) {
    return (
      <tr key={key} onClick={onClick} role={onClick ? 'button' : 'default'}>
        <td>{o.rank}</td>
        <td>{o.name}</td>
        <td>{o.userId}</td>
        <td>{o.points}</td>
        <td>{o.played}</td>
        <td>{o.won}</td>
        <td>{o.drawn}</td>
        <td>{o.lost}</td>
        <td>{o.difference}</td>
      </tr>
    );
  }

  renderThs(cols, hideSort = false) {
    const {order} = this.state;
    return map(cols, (value, key) => (
      <th key={key}>
        <span
          onClick={() => !hideSort && this.selectOrChangeOrder(key)}
          className={classNames('orderBtn', {
            'text-primary': order.key === key && !hideSort,
          })}>
          {value}
          {value && (
            <span className={classNames('ml-1', {hidden: hideSort})}>
              <i
                className={classNames('fa', {
                  'fa-sort': order.key !== key,
                  [`fa-sort-${order.value}`]: order.key === key,
                })}
              />
            </span>
          )}
        </span>
      </th>
    ));
  }

  render() {
    const {isFetching, highlightRefreshBtn} = this.state;

    return (
      <div id="support-league-ranking-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-trophy" />
              {` Ranking`}
            </h3>
          </div>
          <div className="box-body">
            <Filters>
              <FilterInput
                label="DivisionId:"
                onChange={divisionId => {
                  this.updateFilters({divisionId});
                  this.notifyRefresh(true);
                }}
                initialValue={this.state.filters.divisionId}
                inputProps={{
                  type: 'text',
                  placeholder: 'mpg_division_MW7TLFB3_1_1',
                  value: this.state.filters.divisionId,
                }}
              />
              <button
                onClick={() => this.fetchData()}
                style={{marginTop: '25px'}}
                className={classNames('btn', {
                  'btn-primary': highlightRefreshBtn,
                  'btn-default': !highlightRefreshBtn,
                })}>
                <i className="fa fa-search" />
              </button>
            </Filters>
          </div>
          {isFetching && <Loader />}
          <div className="body-table">{this.renderTable()}</div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    data: state.app.support.leagueRanking,
  }),
  dispatch => ({dispatch}),
)(SupportLeagueRankingWidget);



// WEBPACK FOOTER //
// ./src/pages/Support/League/Widgets/LeagueRanking/index.js